var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fit } from "@cloudinary/url-gen/actions/resize";
import { CloudinaryService } from "../services/cloudinary.service";
export var MediaSize;
(function (MediaSize) {
    MediaSize[MediaSize["SMALL_64"] = 64] = "SMALL_64";
    MediaSize[MediaSize["MEDIUM_300"] = 300] = "MEDIUM_300";
    MediaSize[MediaSize["LARGE_600"] = 600] = "LARGE_600";
    MediaSize[MediaSize["XLARGE_1000"] = 1000] = "XLARGE_1000";
})(MediaSize || (MediaSize = {}));
export function getScaledUrl(media, width, height) {
    var _a, _b;
    if (!media)
        return "";
    switch (media.provider) {
        case "cloudinary":
            if (((_a = media.mediaFormat) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "svg") {
                return CloudinaryService.getSanitizedSvgDeliveryUrl(media.mediaURI) || "";
            }
            if (media.publicId && width && height) {
                return (_b = CloudinaryService.getImage(media)) === null || _b === void 0 ? void 0 : _b.resize(fit().width(width).height(height)).toURL();
            }
            else {
                return media.mediaURI;
            }
        default:
            return media.mediaURI;
    }
}
var ASPECT_RATIO_TOLERANCE = 0.1;
var ALLOWED_RATIOS = [1, 16 / 9, 9 / 16];
var VALIDATION_CONFIGS = {
    "image-picker-organization": {
        minWidth: 512,
        minHeight: 128,
    },
    default: {
        minWidth: 128,
        minHeight: 128,
    },
};
var validateFileSize = function (bytes) {
    if (!bytes) {
        return {
            isValid: false,
            message: "File size information is missing",
        };
    }
    var fileSizeInMB = bytes / (1024 * 1024);
    if (fileSizeInMB > 4) {
        return {
            isValid: false,
            message: "File size must not exceed 4MB (current size: ".concat(fileSizeInMB.toFixed(2), "MB)"),
        };
    }
    return { isValid: true };
};
var validateDimensions = function (width, height, minWidth, minHeight) {
    if (width < minWidth || height < minHeight) {
        return "Image dimensions should be at least ".concat(minWidth, "\u00D7").concat(minHeight, "px");
    }
    var aspectRatio = width / height;
    var match = ALLOWED_RATIOS.some(function (r) { return Math.abs(aspectRatio - r) <= ASPECT_RATIO_TOLERANCE; });
    if (!match) {
        return "Image must have an aspect ratio of 1:1, 16:9, or 9:16 (\u00B1".concat((ASPECT_RATIO_TOLERANCE * 100).toFixed(0), "%)");
    }
    return null;
};
export var validateImage = function (result, validationId) { return __awaiter(void 0, void 0, void 0, function () {
    var sizeCheck, config, dimError;
    return __generator(this, function (_a) {
        sizeCheck = validateFileSize(result.bytes);
        if (!sizeCheck.isValid) {
            return [2 /*return*/, {
                    isValid: false,
                    message: "Validation failed because ".concat(sizeCheck.message),
                }];
        }
        config = validationId.includes("image-picker-organization")
            ? VALIDATION_CONFIGS["image-picker-organization"]
            : VALIDATION_CONFIGS.default;
        // 3) dimensions + aspect
        if (result.width == null || result.height == null) {
            return [2 /*return*/, { isValid: false, message: "Image dimensions are missing" }];
        }
        dimError = validateDimensions(result.width, result.height, config.minWidth, config.minHeight);
        if (dimError) {
            return [2 /*return*/, {
                    isValid: false,
                    message: "Validation failed because ".concat(dimError),
                }];
        }
        return [2 /*return*/, { isValid: true }];
    });
}); };
